import React from "react";

// Navigate
import constant from "@/config/constant";
import { useNavigate } from "react-router-dom";

// Mui
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Fade from "@mui/material/Fade";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Components
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { getProducts } from "@/fetch/fetchGiveaway";
import { create, getAll } from "@/fetch/Pharmagood/fetchHiddenOffer";
import _ from "lodash";
import moment from "moment";

// Redux

const HiddenOfferCreatePage = (props) => {
  const { open, setOpen } = props;

  // Navigate and Location and Params
  const navigate = useNavigate();

  //reduxState

  // States
  const [formData, setFormData] = React.useState({
    start_date: moment(),
    end_date: moment(),
    gift_ids: [],
    region_id: [1, 2],
    gift_qty: null,
    product_ids: [],
    category: "",
    name: "",
    product_qty: null,
  });
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [productOptions, setProductOptions] = React.useState([]);
  const [giftOptions, setGiftOptions] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });
  // Submit
  const onClickSubmit = async () => {
    try {
      const data = await create(formData);
      setSnackSeverity("success");
      setSnackMessage("新增成功");
      setSnackOpen(true);
      setTimeout(() => {
        setSnackOpen(false);
        navigate(`/pharmagoodHiddenOffer/${data.id}`);
      }, 1000);
    } catch {
      setSnackSeverity("error");
      setSnackMessage("新增失敗");
      setSnackOpen(true);
    }
  };
  const fetchAll = async () => {
    const { data: gifts } = await getProducts();
    const hiddenOffers = await getAll();
    setCategories(_.uniq(_.map(hiddenOffers, "category")).sort());
    setGiftOptions(gifts);
    setSlideTranOn(true);
  };

  React.useEffect(() => {
    fetchAll();
  }, []);

  return (
    <Layout
      header="GiftSettingCreatePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={17}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`新增Hidden Offer`} history={() => navigate(-1)} />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={theme}>
            <Box validate="true" sx={{ width: 1, flex: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3,
                  }}
                >
                  <TextField
                    id="name"
                    name="name"
                    label="名稱"
                    value={formData.name}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3,
                  }}
                >
                  <Autocomplete
                    id="category"
                    name="category"
                    onChange={(event, newValue) => {
                      setFormData({
                        ...formData,
                        category: newValue,
                      });
                    }}
                    onInputChange={(event, value) => {
                      setFormData({
                        ...formData,
                        category: value,
                      });
                    }}
                    freeSolo
                    value={formData.category}
                    options={categories}
                    renderInput={(params) => (
                      <TextField {...params} label="類別" />
                    )}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 2,
                    lg: 2,
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="select-region">區域</InputLabel>
                    <Select
                      multiple
                      fullWidth
                      id="region_id"
                      name="region_id"
                      label="區域"
                      labelId="select-region"
                      input={<OutlinedInput label="區域" />}
                      renderValue={(selected) => {
                        const selectedValue = _.map(selected, (s) => {
                          return constant.regionType[s];
                        });
                        return selectedValue.join(", ");
                      }}
                      onChange={(event) => {
                        setFormData({
                          ...formData,
                          region_id: event.target.value,
                        });
                      }}
                      value={formData.region_id}
                    >
                      {_.map(constant.regionType, (value, key) => {
                        return (
                          <MenuItem value={parseInt(key)} key={key}>
                            <Checkbox
                              checked={formData.region_id.includes(
                                parseInt(key),
                              )}
                            />
                            <ListItemText primary={value} />
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 2,
                    lg: 2,
                  }}
                >
                  <DatePicker
                    id="start_date"
                    name="start_date"
                    label="開始日期"
                    value={formData.start_date}
                    onChange={(value) => {
                      setFormData({
                        ...formData,
                        start_date: moment(value).format("YYYY-MM-DD"),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  ></DatePicker>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 2,
                    lg: 2,
                  }}
                >
                  <DatePicker
                    id="end_date"
                    name="end_date"
                    label="結束日期"
                    value={formData.end_date}
                    minDate={formData.start_date}
                    onChange={(value) => {
                      setFormData({
                        ...formData,
                        end_date: moment(value).format("YYYY-MM-DD"),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  ></DatePicker>
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <ProductAutoComplete
                    multiple
                    fullWidth
                    sx={{ flex: 1 }}
                    label="購買產品"
                    productOptions={productOptions}
                    handleOnChange={(value) => {
                      setFormData({
                        ...formData,
                        product_ids: value,
                      });
                    }}
                    selectedValue={formData.product_ids ?? []}
                  ></ProductAutoComplete>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    id="product_qty"
                    name="product_qty"
                    label="產品數量"
                    type={"number"}
                    value={formData.product_qty}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <ProductAutoComplete
                    multiple
                    fullWidth
                    sx={{ flex: 1 }}
                    label="贈品"
                    productOptions={giftOptions}
                    handleOnChange={(value) => {
                      setFormData({
                        ...formData,
                        gift_ids: value,
                      });
                    }}
                    selectedValue={formData.gift_ids ?? []}
                  ></ProductAutoComplete>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6,
                  }}
                >
                  <TextField
                    id="gift_qty"
                    name="gift_qty"
                    type={"number"}
                    label="贈品數量"
                    value={formData.gift_qty}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                  }}
                >
                  <Grid justifyContent={"flex-end"} container spacing={2}>
                    <Grid
                      size={{
                        xs: 12,
                        md: 12,
                        lg: 2,
                      }}
                    >
                      <StyledButton
                        variant="contained"
                        size="small"
                        onClick={onClickSubmit}
                      >
                        <Typography variant="subtitle1" noWrap component="div">
                          確認
                        </Typography>
                      </StyledButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default HiddenOfferCreatePage;
